function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import jQuery from 'jquery';
import ClientSideValidations from './core';
import { absenceLocalValidator, presenceLocalValidator } from './validators/local/absence_presence';
import { acceptanceLocalValidator } from './validators/local/acceptance';
import { formatLocalValidator } from './validators/local/format';
import { numericalityLocalValidator } from './validators/local/numericality';
import { lengthLocalValidator } from './validators/local/length';
import { exclusionLocalValidator, inclusionLocalValidator } from './validators/local/exclusion_inclusion';
import { confirmationLocalValidator } from './validators/local/confirmation';
import { uniquenessLocalValidator } from './validators/local/uniqueness'; // Validators will run in the following order

ClientSideValidations.validators.local = {
  absence: absenceLocalValidator,
  presence: presenceLocalValidator,
  acceptance: acceptanceLocalValidator,
  format: formatLocalValidator,
  numericality: numericalityLocalValidator,
  length: lengthLocalValidator,
  inclusion: inclusionLocalValidator,
  exclusion: exclusionLocalValidator,
  confirmation: confirmationLocalValidator,
  uniqueness: uniquenessLocalValidator
};

jQuery.fn.disableClientSideValidations = function () {
  ClientSideValidations.disable(this);
  return this;
};

jQuery.fn.enableClientSideValidations = function () {
  var _this = this;

  var selectors = {
    forms: 'form',
    inputs: 'input'
  };

  var _loop = function _loop(selector) {
    var enablers = selectors[selector];

    _this.filter(ClientSideValidations.selectors[selector]).each(function () {
      ClientSideValidations.enablers[enablers](this);
    });
  };

  for (var selector in selectors) {
    _loop(selector);
  }

  return this;
};

jQuery.fn.resetClientSideValidations = function () {
  this.filter(ClientSideValidations.selectors.forms).each(function () {
    ClientSideValidations.reset(this);
  });
  return this;
};

jQuery.fn.validate = function () {
  this.filter(ClientSideValidations.selectors.forms).each(function () {
    jQuery(this).enableClientSideValidations();
  });
  return this;
};

jQuery.fn.isValid = function (validators) {
  var obj = jQuery(this[0]);

  if (obj.is('form')) {
    return validateForm(obj, validators);
  } else {
    return validateElement(obj, validatorsFor(this[0].name, validators));
  }
};

var cleanNestedElementName = function cleanNestedElementName(elementName, nestedMatches, validators) {
  for (var validatorName in validators) {
    if (validatorName.match("\\[".concat(nestedMatches[1], "\\].*\\[\\]\\[").concat(nestedMatches[2], "\\]$"))) {
      elementName = elementName.replace(/\[[\da-z_]+\]\[(\w+)\]$/g, '[][$1]');
    }
  }

  return elementName;
};

var cleanElementName = function cleanElementName(elementName, validators) {
  elementName = elementName.replace(/\[(\w+_attributes)\]\[[\da-z_]+\](?=\[(?:\w+_attributes)\])/g, '[$1][]');
  var nestedMatches = elementName.match(/\[(\w+_attributes)\].*\[(\w+)\]$/);

  if (nestedMatches) {
    elementName = cleanNestedElementName(elementName, nestedMatches, validators);
  }

  return elementName;
};

var validatorsFor = function validatorsFor(elementName, validators) {
  if (Object.prototype.hasOwnProperty.call(validators, elementName)) {
    return validators[elementName];
  }

  return validators[cleanElementName(elementName, validators)] || {};
};

var validateForm = function validateForm($form, validators) {
  var valid = true;
  $form.trigger('form:validate:before.ClientSideValidations');
  $form.find(ClientSideValidations.selectors.validate_inputs).each(function () {
    if (!jQuery(this).isValid(validators)) {
      valid = false;
    }

    return true;
  });

  if (valid) {
    $form.trigger('form:validate:pass.ClientSideValidations');
  } else {
    $form.trigger('form:validate:fail.ClientSideValidations');
  }

  $form.trigger('form:validate:after.ClientSideValidations');
  return valid;
};

var passElement = function passElement($element) {
  $element.trigger('element:validate:pass.ClientSideValidations').data('valid', null);
};

var failElement = function failElement($element, message) {
  $element.trigger('element:validate:fail.ClientSideValidations', message).data('valid', false);
};

var afterValidate = function afterValidate($element) {
  return $element.trigger('element:validate:after.ClientSideValidations').data('valid') !== false;
};

var executeValidator = function executeValidator(validatorFunctions, validatorFunction, validatorOptions, $element) {
  for (var validatorOption in validatorOptions) {
    if (!validatorOptions[validatorOption]) {
      continue;
    }

    var message = validatorFunction.call(validatorFunctions, $element, validatorOptions[validatorOption]);

    if (message) {
      failElement($element, message);
      return false;
    }
  }

  return true;
};

var executeValidators = function executeValidators(validatorFunctions, $element, validators) {
  for (var validator in validators) {
    if (!validatorFunctions[validator]) {
      continue;
    }

    if (!executeValidator(validatorFunctions, validatorFunctions[validator], validators[validator], $element)) {
      return false;
    }
  }

  return true;
};

var isMarkedForDestroy = function isMarkedForDestroy($element) {
  if ($element.attr('name').search(/\[([^\]]*?)\]$/) >= 0) {
    var destroyInputName = $element.attr('name').replace(/\[([^\]]*?)\]$/, '[_destroy]');

    if (jQuery("input[name=\"".concat(destroyInputName, "\"]")).val() === '1') {
      return true;
    }
  }

  return false;
};

var executeAllValidators = function executeAllValidators($element, validators) {
  if ($element.data('changed') === false || $element.prop('disabled')) {
    return;
  }

  $element.data('changed', false);

  if (executeValidators(ClientSideValidations.validators.all(), $element, validators)) {
    passElement($element);
  }
};

var validateElement = function validateElement($element, validators) {
  $element.trigger('element:validate:before.ClientSideValidations');

  if (isMarkedForDestroy($element)) {
    passElement($element);
  } else {
    executeAllValidators($element, validators);
  }

  return afterValidate($element);
};

if (!window.ClientSideValidations) {
  window.ClientSideValidations = ClientSideValidations;

  if (!isAMD() && !isCommonJS()) {
    ClientSideValidations.start();
  }
}

function isAMD() {
  return typeof define === 'function' && define.amd; // eslint-disable-line no-undef
}

function isCommonJS() {
  return (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined'; // eslint-disable-line no-undef
}

export default ClientSideValidations;